import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { cityFiltersAtom } from '../store/atoms/cityFiltersAtom';
import type { CityFilters } from '../types/cityFilters';

/**
 * Hook para gerenciar os filtros (client-side) da listagem de Cidades.
 *
 * @returns Filtros atuais e funções para atualizar e resetar.
 */
export function useCityFilters() {
  const [filters, setFilters] = useAtom(cityFiltersAtom);
  const resetFilters = useResetAtom(cityFiltersAtom);

  /**
   * Atualiza parcialmente os filtros. Reseta para a primeira página, exceto
   * quando o próprio `page` é fornecido no `partial` (navegação de páginas).
   */
  const updateFilters = (partial: Partial<CityFilters>) => {
    setFilters(prev => {
      const resetPage = 'page' in partial ? {} : { page: 1 };
      return { ...prev, ...resetPage, ...partial };
    });
  };

  return { filters, updateFilters, resetFilters } as const;
}
